
import Observer from '../../components/PersistentMiniEpg/Helpers/Observer';
const observer = function() {
  var _observer = new Observer();
  var _val;
  return {
    subscribe: function(fn) {
      _observer.subscribe(fn);
    },
    unsubscribe: function(fn) {
      _observer.unsubscribe(fn);
    },
    fire: function(data) {
      _observer.fire(data);
    },
    setValue: function(val){
      _val = val;
    },
    getValue: function(){
      return _val
    }
  };
};
export const convertEventLiveTORecord = observer();



// WEBPACK FOOTER //
// ./src/containers/Search/ObserversSearch.js